<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import { useUserStore } from '@/stores/user';
import config from './../../../config';

import { useLocalizationStore } from '@/stores/localization';
const localizeStore = useLocalizationStore();
const { language } = storeToRefs(useLocalizationStore());
const userStore = useUserStore();

function getImageUrl (name: string){
    return `/themes/${config.Themename}/assets/images/help/${language?.value}/${name}.png`;
}

 
</script>

<template src="./help.html"></template>